export default "__VITE_ASSET__f0ebed3e__"